import { createSelector } from 'reselect';
import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericGet } from '@/_shared/types';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_CONTENTID_START_PATH_KEY } from '@/swagger/constants/contents-orchestrator-keys';
import { KEY_GET_CONTENT_START, API_GET_CONTENT_START } from '../constants';
import { MOCK_RESPONSE_GET_CONTENT_START } from '../mocks';

type API_GET_CONTENT_START_PROPS = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_CONTENTID_START_PATH_KEY
>;

export type RequestGetContentStart = API_GET_CONTENT_START_PROPS['request']['path'];

export type ResponseGetContentStart = API_GET_CONTENT_START_PROPS['response']['body'];

export type CallParamsGetContentStart = Omit<RequestGetContentStart, 'organizationId'> & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

export type CallResponseGetContentStart = ResponseGetContentStart;

type CallErrorGetContentStart = {
  message: string;
  code: number;
  type: string;
  title: string;
  status: number;
};

type CallSelectorsGetContentStart = {
  data?: CallResponseGetContentStart;
};

export const getContentStartCall = createGeneralCall<
  CallParamsGetContentStart,
  CallResponseGetContentStart,
  CallErrorGetContentStart,
  CallSelectorsGetContentStart
>({
  id: KEY_GET_CONTENT_START,
  url:
    ({ payload }) =>
    state => {
      const org = getCurrentOrganization(state);
      return API_GET_CONTENT_START(org as unknown as string, payload.contentId);
    },
  method: 'get',
  paramsSelector:
    ({ payload }) =>
    () => {
      return payload;
    },
  selectors: {
    data: ({ selectors }) => createSelector(selectors.response, res => res || undefined),
  },
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_GET_CONTENT_START : undefined,
});
